<forge-scaffold>
  <forge-toolbar slot="body-header" class="metadata-form--header" style="display: block;">
    <h2 slot="start" fxLayoutAlign="start center" fxLayout="row" class="forge-typography--heading4 tyl-card--header">
      Keyboard Shortcuts
    </h2>
  </forge-toolbar>

  <div slot="body" class="shortcut-body">
    <div fxLayout="column" fxLayoutAlign="space-between start">
      @for (group of groupedShortcuts; track group) {
        <shortcut-group [group]="group.name" [shortcuts]="group.shortcuts">
        </shortcut-group>
      }
    </div>
  </div>

  <forge-toolbar slot="footer" inverted="true">
    <forge-button variant="raised" slot="end" (click)="onCloseClick($event)">
      Close
    </forge-button>
  </forge-toolbar>
</forge-scaffold>
